'use client';

import { useEffect, useRef } from 'react';

/**
 * Whether the last input was a key press rather than a mouse press, as a ref to read in a focus
 * handler. For where `:focus-visible` cannot tell them apart, as on a contenteditable.
 */
export function useKeyboardFocusDetect(): React.RefObject<boolean> {
  const isKeyboard = useRef<boolean>(false);

  useEffect(() => {
    const handleKeyDown = () => {
      isKeyboard.current = true;
    };

    const handleMouseDown = () => {
      isKeyboard.current = false;
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('mousedown', handleMouseDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return isKeyboard;
}
